import React from 'react';
import { Icons } from '../Icons';
import ImageWithFallback from './ImageWithFallback';

const ProductCard = ({ product, catName, go }) => {
  const tagMap = { hot: 'HOT', new: 'NEW', sale: 'SALE', best: 'BESTSELLER' };

  return (
    <div className="prod-card">
      <div className="prod-img">
        <ImageWithFallback
          src={product.img}
          alt={product.name}
        />
        {product.tag && <span className={`prod-tag ${product.tag}`}>{tagMap[product.tag]}</span>}
      </div>
      <div className="prod-body">
        <div className="prod-cat-label">{catName}</div>
        <div className="prod-name">{product.name}</div>
        <div className="prod-desc">{product.desc}</div>
        <div className="prod-footer">
          <button className="btn btn-primary btn-sm" onClick={() => go('contact')}>
            Order Now <Icons.ArrowRight size={12} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;